<template>
<div class="chapter">
<div class="inner_page">
<p class="block_5">The Ice Maiden’s Tale</p>
<p class="block_6">Lisa Preziosi</p>
<p class="block_7">Xist Publishing</p>
<p class="block_8" id="calibre_pb_2"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?aab93a56